// extracted by mini-css-extract-plugin
export default {"sectionContent":"nurKvkr3Ia4mEWRR","detailsRow":"or29BkCfyo0vJJnR","detailsLabel":"oKe9UTljlO4xVRQz","detailsValue":"MZuegr8rICIpr_3y","website":"vsbASKcbmY9x_NEc"};